import React, { useState } from 'react';
import "./css/Navbar.css";
import { Link } from 'react-router-dom';
import logo from "../assets/logo.png";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className='main-header-div'>
            <div className='menu-icon' onClick={() => setIsMenuOpen(!isMenuOpen)}>
                {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </div>

            <div className={`link-div ${isMenuOpen ? 'active' : ''}`}>
                <Link to='/' onClick={() => setIsMenuOpen(false)}>Home</Link>
                <p className='slash-style'>/</p>
                <Link to='/about' onClick={() => setIsMenuOpen(false)}>About</Link>
                <p className='slash-style'>/</p>
                <Link to='/contact' onClick={() => setIsMenuOpen(false)}>Contact</Link>
                <p className='slash-style'>/</p>
                <Link to='/gallery' onClick={() => setIsMenuOpen(false)}>Gallery</Link>
                <p className='slash-style'>/</p>
                <Link to='/services' onClick={() => setIsMenuOpen(false)}>Our Services</Link>
            </div>

            <div className='logo-div'>
                <Link to='/'><img src={logo} alt="logo"/></Link>
            </div>

            <div className='contact-div'>
                <p className='contact-us-text'>Contact Us</p>
                <p className='contact-us-slash'>/</p>
                <p className='contact-us-text'>dhimanwoodwork41@gmail.com</p>
                <p className='contact-us-slash'>/</p>
                <p className='contact-us-text'><div style={{display:"flex",flexDirection:"column"}}>+91 9814562530 , +91 7807462535,+91 82858 70007</div></p>
                
            </div>
        </header>
    );
};

export default Header;
